import {
  Avatar,
  Box,
  Card as MUICard,
  CardContent,
  CardHeader,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";

export default function Card({ item, setData }) {
  return (
    <MUICard
      sx={{
        minHeight: 100,
        borderBottom: "1px solid",
        borderBottomColor: "grey.300",
        borderRadius: 0,
      }}
    >
      <CardHeader
        sx={{ "& span": { fontWeight: "500" } }}
        avatar={
          <Avatar
            sx={{
              bgcolor: "success.light",
              width: 30,
              height: 30,
              typography: "caption",
            }}
          >
            DRV
          </Avatar>
        }
        title={<Box sx={{ textTransform: "capitalize" }}>{item.driver}</Box>}
      />
      <CardContent sx={{ pt: 1, pb: "8px !important" }}>
        <Stack
          direction="row"
          sx={{ justifyContent: "space-between", alignItems: "center" }}
        >
          <Stack direction="row" gap={1} sx={{ mr: 1, alignItems: "center" }}>
            <Typography sx={{ whiteSpace: "no-wrap" }} variant="caption">
              Vehicle: {item.vehicleNum} - {item.vehicleLabel}
            </Typography>
          </Stack>
          <Typography variant="caption">Speed: {item.speed} mph</Typography>
        </Stack>
      </CardContent>
    </MUICard>
  );
}
